export type QueryString = `?${string}` | "";

export function isQueryString(value: unknown): value is QueryString {
	return typeof value === "string" && value.indexOf("?") === 0;
}

export function QueryString(value: unknown): QueryString {
	if (isQueryString(value)) {
		return value;
	}
	if (typeof value !== "string") {
		throw new Error(`QueryString must be a string; passed ${typeof value}!`);
	}
	return `?${value}`;
}
